<template>
  <div class="form-group">
    <label for="name">Name</label>
    <BootstrapField
      type="text"
      name="name"
      placeholder="Name"
      rules="required"
    />
  </div>
  <div class="form-group" v-if="ticketing_enabled">
    <div class="form-check">
      <Field
        id="ticket_relevant"
        class="form-check-input"
        type="checkbox"
        name="ticket_relevant"
        :value="true"
      />
      <label class="form-check-label" for="ticket_relevant"
        >Die Schichten in dieser Aufgabe ermöglichen es dem Crewmitglied ein
        Ticket zu erhalten</label
      >
    </div>
  </div>
  <div class="form-group">
    <div class="form-check">
      <Field
        id="locked"
        class="form-check-input"
        type="checkbox"
        name="locked"
        :value="true"
      />
      <label class="form-check-label" for="locked"
        >Die Schichten sperren
        <small
          >(kein Crewmitglied kann sich selbst in die Schichten
          eintragen)</small
        ></label
      >
    </div>
  </div>
  <div class="form-group">
    <QuillField name="description" label="Beschreibung" />
  </div>
  <div class="form-group">
    <h2>Schichten</h2>
    <FieldArray name="shifts" v-slot="{ fields, push, remove }">
      <div
        class="input-group mb-2"
        v-for="(entry, i) in fields"
        :key="entry.key"
      >
        <div
          class="input-group-append input-group-text"
          v-if="shiftNextDay(i, entry, values)"
        >
          +1 Tag
        </div>
        <div class="input-group-prepend input-group-text">
          <span class="fa fa-clock-o"></span>
        </div>
        <BootstrapField
          type="datetime-local"
          :name="`shifts[${i}].start`"
          rules="required"
          :disabled="entry.value.user_id && !entry.value.reserved"
        />
        <div class="input-group-text">bis</div>
        <BootstrapField
          type="datetime-local"
          :name="`shifts[${i}].end`"
          rules="required"
          :disabled="entry.value.user_id && !entry.value.reserved"
        />
        <div
          class="input-group-append input-group-text"
          v-if="endNextDay(entry)"
        >
          +1 Tag
        </div>
        <div class="input-group-append">
          <button class="btn btn-danger" @click.prevent="remove(i)">
            <span class="fa fa-remove"></span>
          </button>
        </div>
      </div>
      <button
        class="btn btn-primary"
        @click.prevent="push(nextShift(values, true))"
      >
        <span class="fa fa-plus"></span>
      </button>
      <button
        class="btn btn-primary ml-1"
        @click.prevent="push(nextShift(values, false))"
      >
        <span class="fa fa-copy"></span>
      </button>
    </FieldArray>
  </div>
</template>

<script>
import { Field, FieldArray } from "vee-validate";
import BootstrapField from "./BootstrapField.vue";
import moment from "moment";
import { mapState } from "pinia";
import { useConfigStore } from "../stores/config";
import QuillField from "./QuillField.vue";

export default {
  name: "TaskForm",
  props: ["values", "startDate"],
  components: { Field, BootstrapField, FieldArray, QuillField },
  computed: {
    ...mapState(useConfigStore, ["ticketing_enabled"]),
  },
  methods: {
    shiftNextDay(i, entry, values) {
      if (i == 0) return false;
      var start = moment(entry.value.start);
      var end = moment(values.shifts[i - 1].end);
      if (start.isValid && end.isValid()) {
        return start.isAfter(end, "day");
      } else {
        return false;
      }
    },
    endNextDay(shift) {
      var start = moment(shift.value.start);
      var end = moment(shift.value.end);
      if (start.isValid() && end.isValid()) {
        return end.isAfter(start, "day");
      } else {
        return false;
      }
    },
    nextShift(values, increment) {
      let shift = { start: this.startDate, end: this.startDate };

      if (values.shifts && values.shifts.length) {
        if (increment) {
          let start = moment(values.shifts[values.shifts.length - 1].start);
          let end = moment(values.shifts[values.shifts.length - 1].end);
          let nextEnd = end.add(end.diff(start));
          shift = {
            start: values.shifts[values.shifts.length - 1].end,
            end: nextEnd.format("YYYY-MM-DDTHH:mm"),
          };
        } else {
          shift = {
            start: values.shifts[values.shifts.length - 1].start,
            end: values.shifts[values.shifts.length - 1].end,
          };
        }
      }
      return shift;
    },
  },
};
</script>

<style scoped></style>
